import { styled } from "styled-components";
import { device } from "../../styles/style";

export const Img = styled.img`
  position: fixed;
  width: 200px;
  top: 25px;
  left: 25px;
  cursor: pointer;
  z-index: 10;

  @media ${device.mobileS} and ${device.mobileM} {
    width: 100px;
    left: 20px;
  }
  @media${device.tv} {
    width: 200px;
  }

  @media${device.tvL} {
    width: 300px;
  }

  @media${device.uhd} {
    width: 400px;
  }
`;
